import React, { useState } from 'react';
import { useAddNewQuoteMutation } from './quotesApiSlice';
import { useNavigate } from 'react-router-dom';

const NewQuote = () => {
  const [formData, setFormData] = useState({
    text: '', author: '', category: '', language: 'hi'
  });
  const [addNewQuote] = useAddNewQuoteMutation();
  const navigate = useNavigate();

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    await addNewQuote(formData);
    navigate('/dashboard/quotes');
  };

  return (
    <div>
      <h2>Add New Quote</h2>
      <form onSubmit={handleSubmit}>
        <input type="text" name="text" placeholder="Quote" value={formData.text} onChange={handleChange} required /><br />
        <input type="text" name="author" placeholder="Author" value={formData.author} onChange={handleChange} /><br />
        <input type="text" name="category" placeholder="Category" value={formData.category} onChange={handleChange} /><br />
        <select name="language" value={formData.language} onChange={handleChange}>
          <option value="hi">Hindi</option>
          <option value="en">English</option>
        </select><br />
        <button type="submit">Save</button>
      </form>
    </div>
  );
};

export default NewQuote;